export const weightTypes = {
    FIX: 'fix',
    VARIABLE: 'variable',
};
